module.exports = __webpack_public_path__ + "img/bm.0fdefae8.svg";